import axios from '@/plugins/axios';
import apiUrls from '@/config/apiUrls';
import { errorToast } from '@/utils/toastUtils';

export const getDiagConfig = async () => {
  try {
    const url = (apiUrls.getDiagConfig as () => string)();
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};

export const getDiagInfo = async () => {
  try {
    const url = (apiUrls.getDiagInfo as () => string)();
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(error);
    errorToast((error as any).response.data);
  }
};
